import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalStatusDelete = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    validity: { setValidity },
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.deleteStatus');
  const onClose = () => {
    closeSingleModal('deleteStatus');
    setValidity('selected.status', null);
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Excluir status"
      height={'auto'}
      width={'30vw'}
    >
      <Form.Validity.Status.Delete />
    </Modal>
  );
};

export default ModalStatusDelete;
